import { LocaleGender } from '../../Types.js'

const values: LocaleGender = {
  binary: ['Female', 'Male'],
  pool: [
    'Asexual',
    'Female to male trans man',
    'Female to male transgender man',
    'Female to male transsexual man',
    'F2M',
    'Gender neutral',
    'Hermaphrodite',
    'Intersex man',
    'Intersex person',
    'Intersex woman',
    'Male to female trans woman',
    'Male to female transgender woman',
    'Male to female transsexual woman',
    'Man',
    'M2F',
    'Polygender',
    'T* man',
    'T* woman',
    'Two* person',
    'Two-spirit person',
    'Woman',
    'Agender',
    'Androgyne',
    'Androgynes',
    'Androgynous',
    'Bigender',
    'Cis',
    'Cis Female',
    'Cis Male',
    'Cis Man',
    'Cis Woman',
    'Cisgender',
    'Cisgender Female',
    'Cisgender Male',
    'Cisgender Man',
    'Cisgender Woman',
    'Female to Male',
    'FTM',
    'Gender Fluid',
    'Gender Nonconforming',
    'Gender Questioning',
    'Gender Variant',
    'Genderqueer',
    'Intersex',
    'Male to Female',
    'MTF',
    'Neither',
    'Neutrois',
    'Non-binary',
    'Other',
    'Pangender',
    'Trans',
    'Trans Female',
    'Trans Male',
    'Trans Man',
    'Trans Person',
    'Trans*Female',
    'Trans*Male',
    'Trans*Man',
    'Trans*Person',
    'Trans*Woman',
    'Transexual',
    'Transexual Female',
    'Transexual Male',
    'Transexual Man',
    'Transexual Person',
    'Transexual Woman',
    'Transgender Female',
    'Transgender Person',
    'Transmasculine',
    'Two-spirit',
  ],
}

export default values
